// extracted by mini-css-extract-plugin
export default {"kvLabel":"kvLabel---WJUiM","kvRoot":"kvRoot---LbmOM","kvValue":"kvValue---ssKIW","kvSub":"kvSub---m4FQc"};